var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88749 2.91663C4.77916 2.91663 3.41666 4.36079 3.41666 6.59663V13.4033C3.41666 15.6391 4.77916 17.0833 6.88749 17.0833H14.1108C16.22 17.0833 17.5833 15.6391 17.5833 13.4033V6.59663C17.5833 4.36079 16.22 2.91663 14.1117 2.91663H6.88749ZM14.1108 18.3333H6.88749C4.06332 18.3333 2.16666 16.3516 2.16666 13.4033V6.59663C2.16666 3.64829 4.06332 1.66663 6.88749 1.66663H14.1117C16.9358 1.66663 18.8333 3.64829 18.8333 6.59663V13.4033C18.8333 16.3516 16.9358 18.3333 14.1108 18.3333Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51124 12.6025C9.35207 12.6025 9.19124 12.5417 9.06957 12.4192L7.09124 10.4417C6.84707 10.1975 6.84707 9.8025 7.09124 9.55833C7.3354 9.31416 7.7304 9.31416 7.97457 9.55833L9.51124 11.0933L13.0246 7.58083C13.2687 7.33666 13.6637 7.33666 13.9079 7.58083C14.1521 7.825 14.1521 8.22 13.9079 8.46416L9.9529 12.4192C9.83124 12.5417 9.67124 12.6025 9.51124 12.6025Z",
    fill: "#515151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.4bbbe4c8dcea2866985ba291757ab203.svg";
export { ForwardRef as ReactComponent };